import { FormControlLabel } from "@mui/material";
import { Dispatch, SetStateAction } from "react";
import ChainNameSingleSelection from "src/components/ContractSweepRecipientSetting/ChainNameSingleSelection";
import CurrencySingleSelection from "src/components/ContractSweepRecipientSetting/CurrencySingleSelection";
import MpTextFieldNumberOnly from "src/components/MpTextFieldNumberOnly";
import { Box, Checkbox } from "src/components/MuiGenerals";
import { usePageConfigProviderContext } from "src/features/PageConfigProvider";
import { useTranslation } from "src/hooks";
import { AddGroupFields } from "../types/AddGroupFields";
import { TableColumnKey } from "../types/Table";
import MpTextField from "src/components/MpTextField";
import { NodeTypesEnumSingleSelection } from "src/components/GeneralSelection";
import { SweepDestGroupType } from "@wallet-manager/node-types/dist/src/postgres/const";

type Props = {
  fields: AddGroupFields;
  setFields: Dispatch<SetStateAction<AddGroupFields>>;
};

const AddRecordDialogContent = (props: Props) => {
  const { fields, setFields } = props;
  const { translatePrefix } = usePageConfigProviderContext();
  const { t, tc } = useTranslation(translatePrefix);

  return (
    <Box
      sx={{
        "& .MuiFormControl-root": {
          width: "100%",
        },
      }}>
      <ChainNameSingleSelection
        fieldName={t(TableColumnKey.ChainName)}
        value={fields.chainName}
        onChange={(e) =>
          setFields((f) => ({ ...f, chainName: e.target.value }))
        }
      />
      <CurrencySingleSelection
        fieldName={t(TableColumnKey.Currency)}
        value={fields.assetName}
        onChange={(e) =>
          setFields((f) => ({
            ...f,
            assetName: e.target.value,
          }))
        }
        chainName={fields.chainName}
      />
      <NodeTypesEnumSingleSelection
        label={tc("phSelection", {
          fieldName: t(TableColumnKey.GroupType),
        })}
        value={fields.groupType}
        onChange={(e) =>
          setFields((f) => ({ ...f, groupType: e.target.value }))
        }
        enumData={SweepDestGroupType}
        clearSelect={() => {}}
      />

      <MpTextField
        label={tc("phInputField", {
          fieldName: t(TableColumnKey.GroupSequence),
        })}
        onChange={(e) => {
          if (fields.groupSequence + e.target.value === "0") {
            return;
          }
          setFields((f) => ({ ...f, groupSequence: e.target.value }));
        }}
        value={fields.groupSequence}
      />

      <MpTextFieldNumberOnly
        label={tc("phInputField", {
          fieldName: t(TableColumnKey.RotateAmountLimit),
        })}
        value={fields.rotateAmountLimit}
        disabled={fields.unlimitAmount}
        onChange={(e) => {
          setFields((f) => ({ ...f, rotateAmountLimit: e.target.value }));
        }}
      />
      <MpTextFieldNumberOnly
        label={tc("phInputField", {
          fieldName: t(TableColumnKey.MaximumAmountLimit),
        })}
        value={fields.maximumAmountLimit}
        disabled={fields.unlimitAmount}
        onChange={(e) => {
          setFields((f) => ({ ...f, maximumAmountLimit: e.target.value }));
        }}
      />
      <FormControlLabel
        control={
          <Checkbox
            checked={fields.unlimitAmount}
            onChange={(e) => {
              setFields((f) => ({ ...f, unlimitAmount: e.target.checked }));
            }}
          />
        }
        label={t("unlimitAmount")}
      />
    </Box>
  );
};

export default AddRecordDialogContent;
